import { create } from "zustand";
import type { IUserLoginResponse } from "../types/auth.ts";
import { setCookie, removeCookie } from "react-use-cookie";
import { AuthStatusEnum } from "../types/auth.ts";

type AuthStore = {
  status: AuthStatusEnum;
  user?: IUserLoginResponse;
  token: string;
  logIn: (user: IUserLoginResponse) => void;
  updateTokens: (accessToken: string, newRefreshToken: string) => void;
  logOut: () => void;
};

export const useAuth = create<AuthStore>()((set) => ({
  status: AuthStatusEnum.LOADING,
  user: undefined,
  token: "",
  logIn: (user: IUserLoginResponse) => {
    set({ status: AuthStatusEnum.LOGGED_IN, user, token: user.token });
    setCookie("token", JSON.stringify(user));
  },
  updateTokens: (accessToken: string, newRefreshToken: string) => {
    set((state) => {
      const updated: IUserLoginResponse | undefined = state.user
        ? { ...state.user, token: accessToken, refreshToken: newRefreshToken }
        : undefined;
      if (updated) {
        setCookie("token", JSON.stringify(updated));
      }
      return { user: updated, token: accessToken };
    });
  },
  logOut: () => {
    set({
      status: AuthStatusEnum.LOGGED_OUT,
      user: undefined,
      token: "",
    });
    removeCookie("token");
  },
}));
